module.exports = __webpack_public_path__ + "img/KIDSSUIT-TITLE-01-MOBILE.02cb3cf5.png";